import * as Yup from 'yup';

export const policyDetailsValidationSchema = () =>
  Yup.object({
    policyReinsuranceSubstandard: Yup.string().required('Required'),
    policyReinsuranceSubstandardLimit: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .typeError('Required')
      .when('policyReinsuranceSubstandard', {
        is: 'YES',
        then: (schema) =>
          schema
            .required('Required')
            .min(0, 'Minimum is 0')
            .max(999, 'Maximum is 999'),
        otherwise: (schema) => schema.notRequired()
      })
  });
